// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shop-page {
    background-color: #fff;
    font-family: 'Noto Sans KR', sans-serif;
}

.shop-breadcrumb {
    padding: 20px 40px;
    background-color: #f8f8f8;
    border-bottom: 1px solid #eee;
}

.breadcrumb-content {
    max-width: 1350px;
    margin: 0 auto;
    font-size: 14px;
    color: #666;
}

.breadcrumb-content span {
    margin: 0 5px;
}

.breadcrumb-content a {
    text-decoration: none;
    color: #666;
}

.breadcrumb-content .current {
    font-weight: bold;
    color: #222;
}

.shop-main-content {
    display: flex;
    max-width: 1350px;
    margin: 40px auto;
    gap: 60px;
}

.category-sidebar {
    width: 250px;
    flex-shrink: 0;
}

.category-sidebar h3 {
    font-size: 20px;
    font-weight: 500;
    padding-bottom: 15px;
    border-bottom: 2px solid #222;
    margin: 0 0 10px 0;
}

.category-sidebar ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.category-sidebar li {
    margin: 2px 0;
    border-radius: 5px;
}

.category-sidebar li:hover {
    background-color: #f8f8f8;
}

.category-sidebar li.active {
    background-color: #f3f3f3;
}

/* 새로운 버튼 스타일 */
.category-button {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 10px;
    background: none;
    border: none;
    text-align: left;
    cursor: pointer;
    border-radius: 5px;
    transition: all 0.2s ease;
    font-family: inherit;
    font-size: 16px;
    font-weight: 500;
    color: #333;
}

.category-button:hover {
    background-color: #f8f8f8;
}

.category-button:active {
    transform: translateY(1px);
    background-color: #e8e8e8;
}

.category-button:focus {
    outline: 2px solid #E84100;
    outline-offset: 2px;
}

.category-button .count {
    font-size: 16px;
    color: #888;
    margin-left: auto;
    flex-shrink: 0;
}

.category-sidebar li.active .category-button {
    color: #E84100;
    font-weight: bold;
    background-color: #f3f3f3;
}

.category-sidebar li.active .category-button .count {
    color: #E84100;
    font-weight: bold;
}

.active-dot {
    color: #E84100;
    font-weight: bold;
    margin-right: 5px;
}

.subcategory-list {
    margin-left: 20px;
    margin-top: 10px;
    border-left: 2px solid #f0f0f0;
    padding-left: 15px;
}

.subcategory-list li {
    margin: 1px 0;
    border-radius: 5px;
    position: relative;
}

.subcategory-list li:hover {
    background-color: #f8f8f8;
}

.subcategory-list li.active {
    background-color: #f3f3f3;
}

/* 서브카테고리 버튼 스타일 */
.subcategory-button {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 5px;
    background: none;
    border: none;
    text-align: left;
    cursor: pointer;
    border-radius: 5px;
    transition: all 0.2s ease;
    font-family: inherit;
    font-size: 14px;
    font-weight: 400;
    color: #333;
}

.subcategory-button:hover {
    background-color: #f8f8f8;
}

.subcategory-button:active {
    transform: translateY(1px);
    background-color: #e8e8e8;
}

.subcategory-button:focus {
    outline: 2px solid #E84100;
    outline-offset: 1px;
}

.subcategory-button .count {
    font-size: 14px;
    color: #888;
    margin-left: auto;
    flex-shrink: 0;
}

.subcategory-list li.active .subcategory-button {
    color: #E84100;
    font-weight: bold;
    background-color: #f3f3f3;
}

.subcategory-list li.active .subcategory-button .count {
    color: #E84100;
    font-weight: bold;
}

.product-listing {
    flex-grow: 1;
}

.listing-header {
    border-bottom: 1px solid #ddd;
    padding-bottom: 15px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.listing-header h2 {
    font-size: 24px;
    font-weight: 500;
    margin: 0;
}

.listing-header-right {
    display: flex;
    align-items: center;
    gap: 20px;
}

.items-per-page-selector {
    display: flex;
    align-items: center;
    gap: 8px;
}

.items-per-page-selector label {
    font-size: 14px;
    color: #666;
}

.items-per-page-select {
    padding: 6px 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    background-color: #fff;
    cursor: pointer;
    transition: border-color 0.2s ease;
}

.items-per-page-select:hover {
    border-color: #E84100;
}

.items-per-page-select:focus {
    outline: 2px solid #E84100;
    outline-offset: 2px;
    border-color: #E84100;
}

.shoppage-product-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
}

.shoppage-product-card {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background-color: #fff;
    text-align: center;
    padding: 20px;
    position: relative;
    transition: box-shadow 0.3s ease;
}

.shoppage-product-card:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.shoppage-product-image-container {
    cursor: pointer;
}

.shoppage-product-image-container img {
    max-width: 100%;
    height: auto;
    margin-bottom: 15px;
}

.shoppage-product-image {
    cursor: pointer;
    width: 100%;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
    overflow: hidden;
    border-radius: 6px;
    background-color: #f8f9fa;
}

.shoppage-product-image img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    transition: transform 0.3s ease;
    padding: 10px;
    box-sizing: border-box;
}

.shoppage-product-image:hover img {
    transform: scale(1.05);
}

.image-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f8f9fa;
    border: 1px dashed #dee2e6;
    border-radius: 6px;
}

.fallback-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f8f9fa;
    border: 1px dashed #dee2e6;
    border-radius: 6px;
}

.shoppage-product-info {
    text-align: center;
}

.shoppage-product-info h4 {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin: 0 0 8px 0;
}

.shoppage-product-description {
    font-size: 14px;
    color: #666;
    margin: 0 0 10px 0;
    line-height: 1.4;
}

.shoppage-product-price {
    margin: 10px 0;
}

.shoppage-product-price span {
    font-size: 16px;
    font-weight: bold;
    color: #333;
}

.shoppage-product-price .original-price {
    text-decoration: line-through;
    color: #999;
    margin-right: 8px;
}

.shoppage-product-price .discount-price {
    color: #e84100;
}

.shoppage-product-stock {
    font-size: 14px;
    color: #666;
    margin: 8px 0 0 0;
}

.shoppage-product-actions {
    margin-top: 15px;
}

.add-to-cart-icon-btn {
    background-color: #f5f5f5;
    border: 1px solid #ddd;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
}

.add-to-cart-icon-btn:hover {
    background-color: #e84100;
    border-color: #e84100;
}

.add-to-cart-icon-btn:hover svg {
    fill: #fff;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .category-sidebar {
        display: none; /* Or implement a toggle/off-canvas menu */
    }

    .shop-main-content {
        gap: 0;
    }

    .shoppage-product-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .shop-breadcrumb {
        padding: 15px;
    }
    
    .breadcrumb-content {
        font-size: 12px;
    }

    .shop-main-content {
        flex-direction: column;
        margin: 20px auto;
        padding: 0 15px;
        gap: 20px;
    }
    
    .category-sidebar {
        width: 100%;
        order: 2;
    }
    
    .category-sidebar h3 {
        font-size: 18px;
    }
    
    .category-button {
        font-size: 14px;
        padding: 12px 10px;
    }
    
    .subcategory-button {
        font-size: 13px;
        padding: 8px 5px;
    }

    .product-listing {
        width: 100%;
        order: 1;
    }

    .listing-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        margin-bottom: 20px;
    }
    
    .listing-header h2 {
        font-size: 18px;
    }
    
    .product-count {
        font-size: 14px;
    }
    
    .shoppage-product-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 10px;
    }
    
    .shoppage-product-card {
        padding: 10px;
    }
    
    .shoppage-product-info h4 {
        font-size: 14px;
    }
    
    .shoppage-product-details {
        font-size: 12px;
    }
    
    .shoppage-product-description {
        font-size: 12px;
    }
}

/* 페이지네이션 스타일 */
.pagination-container {
    margin-top: 40px;
    padding-top: 30px;
    border-top: 1px solid #eee;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
}

.pagination {
    display: flex;
    align-items: center;
    gap: 5px;
}

.pagination-btn {
    min-width: 36px;
    height: 36px;
    padding: 0 12px;
    border: 1px solid #ddd;
    background-color: #fff;
    border-radius: 4px;
    font-size: 18px;
    font-weight: bold;
    color: #333;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pagination-btn:hover:not(:disabled) {
    background-color: #E84100;
    border-color: #E84100;
    color: #fff;
}

.pagination-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
    background-color: #f5f5f5;
}

.pagination-numbers {
    display: flex;
    align-items: center;
    gap: 5px;
}

.pagination-number {
    min-width: 36px;
    height: 36px;
    padding: 0 8px;
    border: 1px solid #ddd;
    background-color: #fff;
    border-radius: 4px;
    font-size: 14px;
    color: #333;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pagination-number:hover {
    background-color: #f5f5f5;
    border-color: #E84100;
    color: #E84100;
}

.pagination-number.active {
    background-color: #E84100;
    border-color: #E84100;
    color: #fff;
    font-weight: bold;
}

.pagination-number.active:hover {
    background-color: #d63900;
    border-color: #d63900;
}

.pagination-ellipsis {
    padding: 0 8px;
    color: #999;
    font-size: 14px;
}

.pagination-info {
    font-size: 14px;
    color: #666;
}

/* 모바일 페이지네이션 */
@media (max-width: 768px) {
    .listing-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
    }
    
    .listing-header-right {
        width: 100%;
        justify-content: space-between;
    }
    
    .pagination-container {
        margin-top: 30px;
        padding-top: 20px;
    }
    
    .pagination {
        flex-wrap: wrap;
        justify-content: center;
        gap: 3px;
    }
    
    .pagination-btn,
    .pagination-number {
        min-width: 32px;
        height: 32px;
        font-size: 13px;
        padding: 0 6px;
    }
    
    .pagination-numbers {
        gap: 3px;
    }
    
    .pagination-info {
        font-size: 12px;
    }
} `, "",{"version":3,"sources":["webpack://./src/pages/css/ShopPage.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,eAAe;AACf;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA,+BAA+B;AAC/B;IACI;QACI,aAAa,EAAE,0CAA0C;IAC7D;;IAEA;QACI,MAAM;IACV;;IAEA;QACI,qCAAqC;IACzC;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,iBAAiB;QACjB,eAAe;QACf,SAAS;IACb;;IAEA;QACI,WAAW;QACX,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,QAAQ;IACZ;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,qCAAqC;QACrC,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,eAAe;AACf;IACI,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,cAAc;IACd,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA,eAAe;AACf;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,8BAA8B;IAClC;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,uBAAuB;QACvB,QAAQ;IACZ;;IAEA;;QAEI,eAAe;QACf,YAAY;QACZ,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".shop-page {\n    background-color: #fff;\n    font-family: 'Noto Sans KR', sans-serif;\n}\n\n.shop-breadcrumb {\n    padding: 20px 40px;\n    background-color: #f8f8f8;\n    border-bottom: 1px solid #eee;\n}\n\n.breadcrumb-content {\n    max-width: 1350px;\n    margin: 0 auto;\n    font-size: 14px;\n    color: #666;\n}\n\n.breadcrumb-content span {\n    margin: 0 5px;\n}\n\n.breadcrumb-content a {\n    text-decoration: none;\n    color: #666;\n}\n\n.breadcrumb-content .current {\n    font-weight: bold;\n    color: #222;\n}\n\n.shop-main-content {\n    display: flex;\n    max-width: 1350px;\n    margin: 40px auto;\n    gap: 60px;\n}\n\n.category-sidebar {\n    width: 250px;\n    flex-shrink: 0;\n}\n\n.category-sidebar h3 {\n    font-size: 20px;\n    font-weight: 500;\n    padding-bottom: 15px;\n    border-bottom: 2px solid #222;\n    margin: 0 0 10px 0;\n}\n\n.category-sidebar ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.category-sidebar li {\n    margin: 2px 0;\n    border-radius: 5px;\n}\n\n.category-sidebar li:hover {\n    background-color: #f8f8f8;\n}\n\n.category-sidebar li.active {\n    background-color: #f3f3f3;\n}\n\n/* 새로운 버튼 스타일 */\n.category-button {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 15px 10px;\n    background: none;\n    border: none;\n    text-align: left;\n    cursor: pointer;\n    border-radius: 5px;\n    transition: all 0.2s ease;\n    font-family: inherit;\n    font-size: 16px;\n    font-weight: 500;\n    color: #333;\n}\n\n.category-button:hover {\n    background-color: #f8f8f8;\n}\n\n.category-button:active {\n    transform: translateY(1px);\n    background-color: #e8e8e8;\n}\n\n.category-button:focus {\n    outline: 2px solid #E84100;\n    outline-offset: 2px;\n}\n\n.category-button .count {\n    font-size: 16px;\n    color: #888;\n    margin-left: auto;\n    flex-shrink: 0;\n}\n\n.category-sidebar li.active .category-button {\n    color: #E84100;\n    font-weight: bold;\n    background-color: #f3f3f3;\n}\n\n.category-sidebar li.active .category-button .count {\n    color: #E84100;\n    font-weight: bold;\n}\n\n.active-dot {\n    color: #E84100;\n    font-weight: bold;\n    margin-right: 5px;\n}\n\n.subcategory-list {\n    margin-left: 20px;\n    margin-top: 10px;\n    border-left: 2px solid #f0f0f0;\n    padding-left: 15px;\n}\n\n.subcategory-list li {\n    margin: 1px 0;\n    border-radius: 5px;\n    position: relative;\n}\n\n.subcategory-list li:hover {\n    background-color: #f8f8f8;\n}\n\n.subcategory-list li.active {\n    background-color: #f3f3f3;\n}\n\n/* 서브카테고리 버튼 스타일 */\n.subcategory-button {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 5px;\n    background: none;\n    border: none;\n    text-align: left;\n    cursor: pointer;\n    border-radius: 5px;\n    transition: all 0.2s ease;\n    font-family: inherit;\n    font-size: 14px;\n    font-weight: 400;\n    color: #333;\n}\n\n.subcategory-button:hover {\n    background-color: #f8f8f8;\n}\n\n.subcategory-button:active {\n    transform: translateY(1px);\n    background-color: #e8e8e8;\n}\n\n.subcategory-button:focus {\n    outline: 2px solid #E84100;\n    outline-offset: 1px;\n}\n\n.subcategory-button .count {\n    font-size: 14px;\n    color: #888;\n    margin-left: auto;\n    flex-shrink: 0;\n}\n\n.subcategory-list li.active .subcategory-button {\n    color: #E84100;\n    font-weight: bold;\n    background-color: #f3f3f3;\n}\n\n.subcategory-list li.active .subcategory-button .count {\n    color: #E84100;\n    font-weight: bold;\n}\n\n.product-listing {\n    flex-grow: 1;\n}\n\n.listing-header {\n    border-bottom: 1px solid #ddd;\n    padding-bottom: 15px;\n    margin-bottom: 30px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.listing-header h2 {\n    font-size: 24px;\n    font-weight: 500;\n    margin: 0;\n}\n\n.listing-header-right {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n\n.items-per-page-selector {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.items-per-page-selector label {\n    font-size: 14px;\n    color: #666;\n}\n\n.items-per-page-select {\n    padding: 6px 10px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 14px;\n    background-color: #fff;\n    cursor: pointer;\n    transition: border-color 0.2s ease;\n}\n\n.items-per-page-select:hover {\n    border-color: #E84100;\n}\n\n.items-per-page-select:focus {\n    outline: 2px solid #E84100;\n    outline-offset: 2px;\n    border-color: #E84100;\n}\n\n.shoppage-product-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 30px;\n}\n\n.shoppage-product-card {\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    background-color: #fff;\n    text-align: center;\n    padding: 20px;\n    position: relative;\n    transition: box-shadow 0.3s ease;\n}\n\n.shoppage-product-card:hover {\n    box-shadow: 0 4px 12px rgba(0,0,0,0.08);\n}\n\n.shoppage-product-image-container {\n    cursor: pointer;\n}\n\n.shoppage-product-image-container img {\n    max-width: 100%;\n    height: auto;\n    margin-bottom: 15px;\n}\n\n.shoppage-product-image {\n    cursor: pointer;\n    width: 100%;\n    height: 200px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 15px;\n    overflow: hidden;\n    border-radius: 6px;\n    background-color: #f8f9fa;\n}\n\n.shoppage-product-image img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    transition: transform 0.3s ease;\n    padding: 10px;\n    box-sizing: border-box;\n}\n\n.shoppage-product-image:hover img {\n    transform: scale(1.05);\n}\n\n.image-placeholder {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #f8f9fa;\n    border: 1px dashed #dee2e6;\n    border-radius: 6px;\n}\n\n.fallback-placeholder {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #f8f9fa;\n    border: 1px dashed #dee2e6;\n    border-radius: 6px;\n}\n\n.shoppage-product-info {\n    text-align: center;\n}\n\n.shoppage-product-info h4 {\n    font-size: 18px;\n    font-weight: bold;\n    color: #333;\n    margin: 0 0 8px 0;\n}\n\n.shoppage-product-description {\n    font-size: 14px;\n    color: #666;\n    margin: 0 0 10px 0;\n    line-height: 1.4;\n}\n\n.shoppage-product-price {\n    margin: 10px 0;\n}\n\n.shoppage-product-price span {\n    font-size: 16px;\n    font-weight: bold;\n    color: #333;\n}\n\n.shoppage-product-price .original-price {\n    text-decoration: line-through;\n    color: #999;\n    margin-right: 8px;\n}\n\n.shoppage-product-price .discount-price {\n    color: #e84100;\n}\n\n.shoppage-product-stock {\n    font-size: 14px;\n    color: #666;\n    margin: 8px 0 0 0;\n}\n\n.shoppage-product-actions {\n    margin-top: 15px;\n}\n\n.add-to-cart-icon-btn {\n    background-color: #f5f5f5;\n    border: 1px solid #ddd;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.add-to-cart-icon-btn:hover {\n    background-color: #e84100;\n    border-color: #e84100;\n}\n\n.add-to-cart-icon-btn:hover svg {\n    fill: #fff;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .category-sidebar {\n        display: none; /* Or implement a toggle/off-canvas menu */\n    }\n\n    .shop-main-content {\n        gap: 0;\n    }\n\n    .shoppage-product-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .shop-breadcrumb {\n        padding: 15px;\n    }\n    \n    .breadcrumb-content {\n        font-size: 12px;\n    }\n\n    .shop-main-content {\n        flex-direction: column;\n        margin: 20px auto;\n        padding: 0 15px;\n        gap: 20px;\n    }\n    \n    .category-sidebar {\n        width: 100%;\n        order: 2;\n    }\n    \n    .category-sidebar h3 {\n        font-size: 18px;\n    }\n    \n    .category-button {\n        font-size: 14px;\n        padding: 12px 10px;\n    }\n    \n    .subcategory-button {\n        font-size: 13px;\n        padding: 8px 5px;\n    }\n\n    .product-listing {\n        width: 100%;\n        order: 1;\n    }\n\n    .listing-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n        margin-bottom: 20px;\n    }\n    \n    .listing-header h2 {\n        font-size: 18px;\n    }\n    \n    .product-count {\n        font-size: 14px;\n    }\n    \n    .shoppage-product-grid {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 10px;\n    }\n    \n    .shoppage-product-card {\n        padding: 10px;\n    }\n    \n    .shoppage-product-info h4 {\n        font-size: 14px;\n    }\n    \n    .shoppage-product-details {\n        font-size: 12px;\n    }\n    \n    .shoppage-product-description {\n        font-size: 12px;\n    }\n}\n\n/* 페이지네이션 스타일 */\n.pagination-container {\n    margin-top: 40px;\n    padding-top: 30px;\n    border-top: 1px solid #eee;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 15px;\n}\n\n.pagination {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.pagination-btn {\n    min-width: 36px;\n    height: 36px;\n    padding: 0 12px;\n    border: 1px solid #ddd;\n    background-color: #fff;\n    border-radius: 4px;\n    font-size: 18px;\n    font-weight: bold;\n    color: #333;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.pagination-btn:hover:not(:disabled) {\n    background-color: #E84100;\n    border-color: #E84100;\n    color: #fff;\n}\n\n.pagination-btn:disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n    background-color: #f5f5f5;\n}\n\n.pagination-numbers {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.pagination-number {\n    min-width: 36px;\n    height: 36px;\n    padding: 0 8px;\n    border: 1px solid #ddd;\n    background-color: #fff;\n    border-radius: 4px;\n    font-size: 14px;\n    color: #333;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.pagination-number:hover {\n    background-color: #f5f5f5;\n    border-color: #E84100;\n    color: #E84100;\n}\n\n.pagination-number.active {\n    background-color: #E84100;\n    border-color: #E84100;\n    color: #fff;\n    font-weight: bold;\n}\n\n.pagination-number.active:hover {\n    background-color: #d63900;\n    border-color: #d63900;\n}\n\n.pagination-ellipsis {\n    padding: 0 8px;\n    color: #999;\n    font-size: 14px;\n}\n\n.pagination-info {\n    font-size: 14px;\n    color: #666;\n}\n\n/* 모바일 페이지네이션 */\n@media (max-width: 768px) {\n    .listing-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 15px;\n    }\n    \n    .listing-header-right {\n        width: 100%;\n        justify-content: space-between;\n    }\n    \n    .pagination-container {\n        margin-top: 30px;\n        padding-top: 20px;\n    }\n    \n    .pagination {\n        flex-wrap: wrap;\n        justify-content: center;\n        gap: 3px;\n    }\n    \n    .pagination-btn,\n    .pagination-number {\n        min-width: 32px;\n        height: 32px;\n        font-size: 13px;\n        padding: 0 6px;\n    }\n    \n    .pagination-numbers {\n        gap: 3px;\n    }\n    \n    .pagination-info {\n        font-size: 12px;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
